import { apiClient }
from "../api/apiClient";

// ===============================
// TYPES
// ===============================

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  userID: number;
  name: string;
  email: string;
  role: string;
  userImage: string;
}

interface ApiResponse<T> {
  isSuccess: boolean;
  message: string;
  data: T;
}

// ===============================
// AUTH SERVICE
// ===============================

export const authService = {

  // ===============================
  // LOGIN
  // ===============================

  login: async (
    payload: LoginRequest
  ): Promise<LoginResponse> => {

    const response =
      await apiClient.post<
        ApiResponse<LoginResponse>
      >(
        "/Auth/login",
        payload
      );

    const result =
      response.data;

    if (!result.isSuccess) {

      throw new Error(
        result.message
      );
    }

    return result.data;
  },

  // ===============================
  // REGISTER
  // ===============================

  register: async (
    payload: any
  ) => {

    const response =
      await apiClient.post(
        "/Auth/register",
        payload
      );

    return response.data;
  },
};